<template>
  <div style="max-width: 375px; margin: 0 auto;">
    <div
      id="appleid-signin"
      data-mode="center-align"
      data-type="sign-in"
      data-color="black"
      data-border="false"
      data-border-radius="15"
      data-width="375"
      data-height="40"
    ></div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  ...mapGetters("auth/login", [
    "getInProgress",
    "getSuccess",
    "getErrorMessages",
  ]),
  mounted() {
    const appleSignInEventName = 'AppleIDSignInOnSuccess';

    document.removeEventListener(appleSignInEventName, this.handleAppleSignInSuccess);
    document.addEventListener(
      appleSignInEventName,
      this.handleAppleSignInSuccess,
      { once: true, }
    );

    // eslint-disable-next-line
    AppleID.auth.init({
      clientId : 'storycity.app',
      scope : 'name email',
      redirectURI: window.location.protocol + "//" + window.location.host,
      usePopup : true
    });
  },
  //Remove the event listener
  beforeDestroy() {
      document.removeEventListener('AppleIDSignInOnSuccess', this.handleAppleSignInSuccess);
  },
  methods: {
    handleAppleSignInSuccess(event) {
      if (event?.detail?.authorization?.code) {
        this.loginAction(event.detail.authorization.code);
      }
    },
    loginAction(jwt) {
      this.logIn({ appleToken: jwt, redirect: this.$route.query.redirect });
    },
    ...mapActions("auth/login", ["logIn"]),
  },
}
</script>

